import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { NavigationService } from 'services/navigation.service';
import { UserService } from 'services/user.service';
import { AlertService } from 'services/alert.service';
import { PasswordStrengthValidator } from 'app/shared/validators/password-strength.validators';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.scss']
})
export class ChangepasswordComponent implements OnInit {
  form: FormGroup;
  changepasswordData: any;
  show1: boolean=false;
  show2: boolean=false;
  show3: boolean=false;



  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private route: ActivatedRoute,
    private navigationService: NavigationService,
    private userService: UserService,
    private alertService: AlertService,
    @Optional() public dialogRef: MatDialogRef<ChangepasswordComponent>) {
    if (this.data) {
      this.changepasswordData = JSON.stringify(data);
      this.show1 = false;
      this.show2 = false;
      this.show3 = false;
    }
    this.initializeValidators();

  }
  password1() {
    this.show1 = !this.show1;
  }
  password2() {
    this.show2 = !this.show2;
  }
  password3() {
    this.show3 = !this.show3;
  }


  ngOnInit() {

  }
  initializeValidators() {
    this.form = new FormGroup({
      oldpassword: new FormControl('', [Validators.required]),
      newpassword: new FormControl('', [Validators.required, PasswordStrengthValidator, Validators.minLength(8)]),
      confirmpassword: new FormControl('', [Validators.required]),
      oldPin: new FormControl('', [Validators.minLength(3), Validators.maxLength(5)]),
      pin: new FormControl('', [Validators.minLength(3), Validators.maxLength(5)])
    });
  }

  onSave() {
    if (this.data&& this.data.isPasswordChange != false) {
      if (this.form.valid && (this.form.value.newpassword === this.form.value.confirmpassword)) {
        this.userService.changepasswordUser(this.form.value).subscribe(result => {
          if (result.value) {
            this.navigationService.goToLogin();
            this.alertService.success('Your password has been changed');
            if (this.data && this.data.mandatory === true) {
              this.dialogRef.close(true);
            }
            else {
              this.dialogRef.close(true);
            }
          }
          else {
            this.alertService.error(result.htmlFormattedFailures);
          }
        });
      } else {
        this.validateFormControl();
      }
    }
    else {
      if (this.form.value.oldPin && this.form.value.pin && (this.form.value.oldPin != this.form.value.pin)) {
        var formvalue=this.form.getRawValue()
        this.userService.changePin(formvalue).subscribe(result => {
          if (result==true) {
            this.alertService.success('PIN changed successfully');
            this.dialogRef.close(true);
          } else {
            this.alertService.error(result || 'PIN change failed');
          }
        });
      }
      else if (this.form.value.oldPin == this.form.value.pin) {
        this.alertService.error("Old and new pin can't be same");
      }
    }
  }
  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }
  onCancel() {
    if (this.data && this.data.mandatory === true) {
      this.alertService.warning(
        'Password change is required to continue.'
      );
      return;
    }

    this.dialogRef.close(false);
  }

}
